module.exports = __webpack_public_path__ + "img/symfony.a9992643.png";